import { useRef, useState } from "react";
import { ThreeDotsIcon, IconButton, Menu, MenuItem } from "@flat-ui";
/** Renders a three dot menu for a card */
export function CardActionMenu({
  menu
}) {
  const [isOpen, setIsOpen] = useState(false);
  const button = useRef(null);
  return <>
      <IconButton ref={button} onClick={() => setIsOpen(true)} size="xs">
        <ThreeDotsIcon />
      </IconButton>

      <Menu minWidth="unset" anchorEl={button.current} open={isOpen} onClose={() => setIsOpen(false)}>
        {menu.map(({
        name,
        callback,
        color
      }) => <MenuItem key={name} label={name} color={color} onClick={callback} />)}
      </Menu>
    </>;
}